import { createSelector } from "@reduxjs/toolkit";
import { discoveryPanelsSelector } from "./discoveryPanels.selector";

export const downloadSelector = createSelector(
  discoveryPanelsSelector,
  state => state.download
); 